import { Box, Button, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import SourceTable from './SourceTable'
import DestinationTable from './DestinationTable'
import { connect } from 'react-redux'
import { getBranchAndCityList, getBranchPaymentTypeConfigDetails, getBranchPaymentTypeConfigUpdate } from '../../../../../store/generalSetting/GSAction'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import * as mdt from '../../../../common/modaltypes'
import ConfirmModal from './ConfirmModal'

const LuggageCities = (props) => {
    const {
        data: { common },
        updateModal,
        getBranchAndCityList,
        getBranchPaymentTypeConfigDetails,
        updateAlertError,
        getBranchPaymentTypeConfigUpdate
    } = props
    const { loginData, showModal, modalType,companySettings} = common
    const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
    const [luggageCityFilterList, setLuggageCityFilterList] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [selSourceState, setSelSourceState] = useState('')
    const [selSourceCity, setSelSourceCity] = useState('')
    const [selSourceBranch, setSelSourceBranch] = useState('')
    const [selDestState, setselDestState] = useState('')
    const [selDestCity, setSelDestCity] = useState('')
    const [selDestBranch, setSelDestBranch] = useState('')
    const [filterData, setFilterData] = useState({
        sourceCity: "",
        sourceBranch: '',
    })
    const [destTableData, setDestTableData] = useState([])
    const [sourceTableData, setSourceTableData] = useState([])
    const [successModal, setSuccessModal] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let body = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intBranchID: 0,
                strBranchName: "",
                strBranchCode: "",
                intStateID: 0,
                intCityID: 0,
                intIsActive: 1
            }
            getBranchAndCityList(body, true, 24 * 60 * 60 * 1000).then((res) => {
                if (res.status === 'Success') {
                    setLuggageCityFilterList(res.Data.Table)
                    let newData = removeDuplicatesFromArray(res.Data.Table, 'BranchID')
                    let defaultList = newData.filter((val) => val.BranchID === loginData.intBranchID)
                    if (defaultList.length > 0) {
                        setSelSourceState(defaultList[0])
                        setSelSourceCity(defaultList[0])
                        setSelSourceBranch(defaultList[0])
                    } else {
                        setSelSourceState(newData[0])
                        setSelSourceCity(newData[0])
                        setSelSourceBranch(newData[0])
                    }
                    setselDestState({ StateName: 'All State', StateID: 0 })
                    setSelDestCity({ CityName: 'All City', CityID: 0 })
                    setSelDestBranch({ BranchName: 'All Branch', BranchID: 0 })
                } else {
                    setLuggageCityFilterList([])
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Source_State' })
                }
            })
        }
    }, [loginData])
    const resetAllValue = () => {
        setDestTableData([])
        setShowTable(false)
        setSourceTableData([])
    }
    let sourceCityOpt = removeDuplicatesFromArray(luggageCityFilterList, 'CityID').filter((val) => val.StateID === selSourceState.StateID && selDestCity?.CityID !== val.CityID)
    let sourceBranchOpt = removeDuplicatesFromArray(luggageCityFilterList, 'BranchID').filter((val) => val.CityID === selSourceCity.CityID)
    let destCityOpt = removeDuplicatesFromArray(luggageCityFilterList, 'CityID').filter((val) => (val.StateID === selDestState.StateID || selDestState.StateID === 0) && (selSourceCity?.CityID !== val.CityID))
    let destBranchOpt = removeDuplicatesFromArray(luggageCityFilterList, 'BranchID').filter((val) => selDestCity.CityID === 0 ? selDestState.StateID === 0 ? true : val.StateID === selDestState.StateID : val.CityID === selDestCity.CityID)
    const generatorReport = () => {
        if (selSourceBranch === '' || selSourceBranch === ' ') {
            updateAlertError({ show: true, msg: 'Please select Source Branch', nextId: 'Select_Source_Branch' })
        } else if (selSourceCity === '' || selSourceCity === ' ') {
            updateAlertError({ show: true, msg: 'Please select Source City', nextId: 'Select_Source_City' })
        } else if (selSourceState === '' || selSourceState === ' ') {
            updateAlertError({ show: true, msg: 'Please select Source State', nextId: 'Select_Source_State' })
        } else if (selDestBranch === '' || selDestBranch === ' ') {
            updateAlertError({ show: true, msg: 'Please select Dest. Branch', nextId: 'Select_Dest_Branch' })
        } else if (selDestCity === '' || selDestCity === ' ') {
            updateAlertError({ show: true, msg: 'Please select Dest. City', nextId: 'Select_Dest_City' })
        } else if (selDestState === '' || selDestState === ' ') {
            updateAlertError({ show: true, msg: 'Please select Dest. State', nextId: 'Select_Dest_State' })
        } else {
            resetAllValue()
            const body = {
                CompanyID: loginData?.intCompanyID,
                FromBranchID: selSourceBranch?.BranchID,
                ToCityID: selDestCity?.CityID,
                ToBranchID: selDestBranch?.BranchID,
                ToStateID: selDestState?.StateID
            }
            setFilterData({
                sourceCity: selSourceCity?.CityName,
                sourceBranch: selSourceBranch?.BranchName,
                sourceBranchId: selSourceBranch?.BranchID
            })
            getBranchPaymentTypeConfigDetails(body).then((res) => {
                if (res.status === 'Success') {
                    setSourceTableData(res.Data.Table)
                    setDestTableData(formatDestTableData(res.Data.Table1))
                    setShowTable(true)
                } else {
                    setDestTableData([])
                    setSourceTableData([])
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Source_State' })
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }

    }
    const formatDestTableData = (data) => {
        const groupedData = data.reduce((result, item) => {
            const key = item.Cityid
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        let newData = []
        Object.keys(groupedData).map((val) => {
            let updateData = groupData(groupedData[val]);
            newData = [...newData, ...updateData]
        })
        return newData.sort((a, b) => a.Cityname.localeCompare(b.Cityname))
    }
    const groupData = (value) => {
        let DestTableRow = {
            Cityid: 1,
            Cityname: value[0]?.Cityname,
            IsCOD: value.some(item => item.IsCOD === 1),
            IsDDDV: value.some(item => item.IsDDDV === 1),
            IsFOC: value.some(item => item.IsFOC === 1),
            IsOnAcc: value.some(item => item.IsOnAcc === 1),
            IsOnAccMan: value.some(item => item.IsOnAccMan === 1),
            IsPaid: value.some(item => item.IsPaid === 1),
            IsPaidMan: value.some(item => item.IsPaidMan === 1),
            IsSelf: value.some(item => item.IsSelf === 1),
            IsTopay: value.some(item => item.IsTopay === 1),
            IsTopayMan: value.some(item => item.IsTopayMan === 1),
        }
        return [{ ...DestTableRow, DestinationData: value.sort((a, b) => a.Branchname.localeCompare(b.BranchName)) }]
    }
    const transformedObject = (arr) => {
        const result = {};
        arr.forEach(item => {
            item.DestinationData.forEach(person => {
                Object.keys(person).forEach(key => {
                    if (!result[key]) {
                        result[key] = '';
                    }
                });

                Object.keys(person).forEach(key => {
                    result[key] += person[key] + '^';
                });
            });
        });
        Object.keys(result).forEach(key => {
            result[key] = result[key].slice(0, -1);
        });
        return result
    }
    const saveLuggageCityData = () => {
        let sourceData = sourceTableData[0]
        delete sourceData.Cityname
        let newObject = transformedObject(destTableData);
        const body = {
            CompanyID: loginData?.intCompanyID,
            FromBranchID: filterData?.sourceBranchId,
            ...sourceData,
            BranchID: newObject?.BranchID || '',
            PaidIDs: newObject?.IsPaid || '',
            PaidManIDs: newObject?.IsPaidMan || '',
            TopayIDs: newObject?.IsTopay || '',
            TopayManIDs: newObject?.IsTopayMan || '',
            DDDVIDs: newObject?.IsDDDV || '',
            OnAccIDs: newObject?.IsOnAcc || '',
            OnAccManIDs: newObject?.IsOnAccMan || '',
            CODIDs: newObject?.IsCOD || '',
            SelfIDs: newObject?.IsSelf || '',
            FOCIDs: newObject?.IsFOC || ''
        }
        getBranchPaymentTypeConfigUpdate(body).then((res) => {
            if (res.status === 'Success') {
                generatorReport()
                updateModal(false, mdt.saveLuggageCityData)
                focusElemnt('Select_Source_State')
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Source_State' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    useEffect(() => {
        focusElemnt('Select_Source_State')
    }, [])
    return (
        <Box>
            <Grid container sx={{ display: 'flex', paddingBottom: '6px', paddingTop: '6px' }} >
                <Grid item md={1.7} >
                    <Item sx={{ paddingLeft: '0px !important' }}>
                        <DropDownOA
                            id={"Select_Source_State"}
                            label={"Select Source State"}
                            defaultvalue={selSourceState?.StateName || selSourceState}
                            value={selSourceState?.StateName || selSourceState}
                            data={removeDuplicatesFromArray(luggageCityFilterList, 'StateID')}
                            onSelect={(val) => {
                                resetAllValue()
                                setSelSourceState(val)
                                let defaultCity = removeDuplicatesFromArray(luggageCityFilterList, 'CityID').filter((obj) => obj.StateID === val.StateID)
                                let defaultBranch = removeDuplicatesFromArray(luggageCityFilterList, 'BranchID').filter((obj) => obj.CityID === defaultCity[0]?.CityID)
                                setSelSourceCity(defaultCity[0])
                                setSelSourceBranch(defaultBranch[0])
                            }}
                            dataKey={'StateName'}
                            idKey={'StateID'}
                            nextId={'Select_Source_City'}
                            prevId={showTable ? destTableData.length > 0 ? `DestIcons-${destTableData.length - 1}` : 'searchContain' : 'LoadBtn'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.7} >
                    <Item>
                        <DropDownOA
                            id={"Select_Source_City"}
                            label={"Select Source City"}
                            defaultvalue={selSourceCity?.CityName || selSourceCity}
                            value={selSourceCity?.CityName || selSourceCity}
                            data={sourceCityOpt}
                            onSelect={(val) => {
                                resetAllValue()
                                setSelSourceCity(val)
                                let defaultBranch = removeDuplicatesFromArray(luggageCityFilterList, 'BranchID').filter((obj) => obj.CityID === val?.CityID)
                                setSelSourceBranch(defaultBranch[0])
                            }}
                            dataKey={'CityName'}
                            idKey={'CityID'}
                            nextId={'Select_Source_Branch'}
                            prevId={'Select_Source_State'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.8} >
                    <Item>
                        <DropDownOA
                            id={"Select_Source_Branch"}
                            label={"Select Source Branch"}
                            defaultvalue={selSourceBranch?.BranchName || selSourceBranch}
                            value={selSourceBranch?.BranchName || selSourceBranch}
                            data={sourceBranchOpt}
                            onSelect={(val) => {
                                resetAllValue()
                                setSelSourceBranch(val)
                            }}
                            dataKey={'BranchName'}
                            idKey={'BranchID'}
                            nextId={'Select_Dest_State'}
                            prevId={'Select_Source_City'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.7} >
                    <Item>
                        <DropDownOA
                            id={"Select_Dest_State"}
                            label={"Select Dest. State"}
                            defaultvalue={selDestState?.StateName || selDestState}
                            value={selDestState?.StateName || selDestState}
                            data={[{ StateName: 'All State', StateID: 0 }, ...removeDuplicatesFromArray(luggageCityFilterList, 'StateID')]}
                            onSelect={(val) => {
                                resetAllValue()
                                setselDestState(val)
                                setSelDestCity({ CityName: 'All City', CityID: 0 })
                                setSelDestBranch({ BranchName: 'All Branch', BranchID: 0 })

                            }}
                            dataKey={'StateName'}
                            idKey={'StateID'}
                            nextId={'Select_Dest_City'}
                            prevId={'Select_Source_Branch'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.8} >
                    <Item>
                        <DropDownOA
                            id={"Select_Dest_City"}
                            label={"Select Dest. City"}
                            defaultvalue={selDestCity?.CityName || selDestCity}
                            value={selDestCity?.CityName || selDestCity}
                            data={[{ CityName: 'All City', CityID: 0 }, ...destCityOpt]}
                            onSelect={(val) => {
                                resetAllValue()
                                setSelDestCity(val)
                                setSelDestBranch({ BranchName: 'All Branch', BranchID: 0 })
                            }}
                            dataKey={'CityName'}
                            idKey={'CityID'}
                            nextId={'Select_Dest_Branch'}
                            prevId={'Select_Dest_State'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.8} >
                    <Item>
                        <DropDownOA
                            id={"Select_Dest_Branch"}
                            label={"Select Dest. Branch"}
                            defaultvalue={selDestBranch?.BranchName || selDestBranch}
                            value={selDestBranch?.BranchName || selDestBranch}
                            data={[{ BranchName: 'All Branch', BranchID: 0 }, ...destBranchOpt]}
                            onSelect={(val) => {
                                resetAllValue()
                                setSelDestBranch(val)
                            }}
                            dataKey={'BranchName'}
                            idKey={'BranchID'}
                            nextId={'LoadBtn'}
                            prevId={'Select_Dest_City'}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.4} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Item sx={{ ...sx.itemsx, marginTop: '7px !important', paddingX: '8px' }} className="disabled-wrapper">
                        <Button variant="contained" id='LoadBtn' sx={{ width: '100%', paddingY: "6px !important" }} className="btn btn-primary" onClick={generatorReport}
                            onKeyDown={(e) => {
                                navigation3(e, showTable ? 'saveBtn' : 'Select_Source_State', 'Select_Dest_Branch', () => { })
                            }}
                        >
                            LOAD
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, marginTop: '7px !important', paddingX: '8px' }} className="disabled-wrapper">
                        <Button variant="contained" id='saveBtn' disabled={!showTable} sx={{ width: '100%', paddingY: "6px !important" }} className="btn btn-primary"
                            onClick={() => {
                                updateModal(true, mdt.saveLuggageCityData)
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, 'activeBtn', 'LoadBtn', () => { })
                            }}
                        >
                            SAVE
                        </Button>
                    </Item>
                </Grid>
            </Grid>
            {showTable &&
                <>
                    <Box>
                        <FormControlLabel
                            control={<Checkbox checked={sourceTableData.length > 0 && sourceTableData[0]?.IsPolicyEnabled === 1} />}
                            label={
                                <Typography variant='h6' sx={{ fontWeight: '500', fontSize: '16px', color: '#0086FF' }}>
                                    Use the New Luggage Cities Policy.
                                </Typography>
                            }
                        />
                        <Button variant="outlined" id='activeBtn' className='activeBtn' onClick={() => {
                            setSuccessModal(true)
                            let newArr = [...sourceTableData];
                            newArr[0].IsPolicyEnabled = newArr[0].IsPolicyEnabled == 0 ? 1 : 0
                            setSourceTableData(newArr)
                        }}
                            onKeyDown={(e) => {
                                navigation3(e, sourceTableData.length > 0 ? 'IsPaid-0' : 'searchContain', 'saveBtn', () => { })
                            }}
                        >
                            {sourceTableData[0]?.IsPolicyEnabled === 1 ? "Deactivate" : "Activate"}
                        </Button>
                    </Box>
                    <Box>
                        <SourceTable UseToPayAsCOD={UseToPayAsCOD} filterData={filterData} tableData={sourceTableData} setTableData={setSourceTableData} destTableData={destTableData} setDestTableData={setDestTableData} />
                    </Box>
                    <Box >
                        <DestinationTable UseToPayAsCOD={UseToPayAsCOD} tableData={destTableData} setTableData={setDestTableData} sourceTableData={sourceTableData} />
                    </Box>
                </>
            }
            <SuccessAndErrorModal handleClose={() => { setSuccessModal(false); focusElemnt('activeBtn') }} open={successModal} title={`Luggage Cities Policy\nSaved Successfully!`} modalStyle={modalStyle} />
            {showModal && mdt.saveLuggageCityData === modalType ? <ConfirmModal updateModal={updateModal} saveLuggageCityData={saveLuggageCityData} /> : null}
        </Box>

    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchAndCityList, getBranchPaymentTypeConfigDetails, updateAlertError, getBranchPaymentTypeConfigUpdate, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(LuggageCities)